export default {
    dependencies: ['$element', 'finnboxservice'],
    callable(element, service) {
        const toolbar = element.querySelector('[data-action=toolbar]');
        const deleteButton = element.querySelector('[data-action=delete]');
        const conversationId = element.getAttribute('data-conversation-id');
        let confirmationDialogElement;
        let confirmButton;
        let cancelButton;

        init();
        return {
            collapseRow,
        };

        function init() {
            if (deleteButton) {
                deleteButton.addEventListener('click', deleteRow);
            }
        }

        function deleteRow() {
            showConfirmationDialog();
        }

        function collapseRow() {
            hideElement(element);
        }

        function handleCancelClick() {
            hideConfirmationDialog();
        }

        function handleConfirmClick() {
            service.deleteConversations([conversationId], () => {
                collapseRow();
            });
        }

        function showConfirmationDialog() {
            if (!confirmationDialogElement) {
                setupConfirmationDialog(
                    'Vil du slette meldingene?',
                    'Slett',
                    'Avbryt'
                );
            }
            toolbar.appendChild(confirmationDialogElement);
            hideElement(deleteButton);
        }

        function hideConfirmationDialog() {
            toolbar.removeChild(confirmationDialogElement);
            showElement(deleteButton);
        }

        function setupConfirmationDialog(message, confirmLabel, cancelLabel) {
            confirmationDialogElement = document.createElement('div');
            confirmationDialogElement.className = 'fleft';
            confirmationDialogElement.innerHTML = [
                '<span class="message largetext prl">',
                message,
                '</span>',
                '<button data-action="confirm" class="fit-height blank cherry largetext pvm mlm">',
                confirmLabel,
                '</button>',
                '<button data-action="cancel" class="blank fit-height secondary-blue  largetext pvm mll">',
                cancelLabel,
                '</button>',
            ].join('');
            confirmButton = confirmationDialogElement.querySelector(
                '[data-action=confirm]'
            );
            cancelButton = confirmationDialogElement.querySelector(
                '[data-action=cancel]'
            );
            confirmButton.addEventListener('click', handleConfirmClick);
            cancelButton.addEventListener('click', handleCancelClick);
        }

        function hideElement(el) {
            if (el != null) {
                el.classList.add('hidden');
            }
        }

        function showElement(el) {
            if (el != null) {
                el.classList.remove('hidden');
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxConversationsRow.js